export default "__VITE_ASSET__27423daf__"